module.exports = __webpack_public_path__ + "img/ZM.112bea3f.svg";